import { render, staticRenderFns } from "./BodyguardServiceFormVehicular.vue?vue&type=template&id=1a4f4be5"
import script from "./BodyguardServiceFormVehicular.vue?vue&type=script&lang=js"
export * from "./BodyguardServiceFormVehicular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports